import { render } from "./Projects.vue?vue&type=template&id=6c3afadf&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=6c3afadf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3afadf"],['__file',"src/pages/ddv-home/Projects.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c3afadf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c3afadf', __exports__)) {
    api.reload('6c3afadf', __exports__)
  }
  
  module.hot.accept("./Projects.vue?vue&type=template&id=6c3afadf&scoped=true", () => {
    api.rerender('6c3afadf', render)
  })

}


export default __exports__